import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Contact.css';
import { sendContactEmail } from '../services/googleServices';

const Contact = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    service: '',
    businessSize: '',
    message: '',
    newsletter: false
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [notification, setNotification] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const validateForm = () => {
    if (!formData.name || !formData.email || !formData.service || !formData.message) {
      // showNotification('Please fill in all required fields.', 'error');
      return false;
    }

    if (!isValidEmail(formData.email)) {
      // showNotification('Please enter a valid email address.', 'error');
      return false;
    }

    return true;
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // const showNotification = (message, type) => {
  //   setNotification({ message, type });
  //   setTimeout(() => setNotification(null), 5000);
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    try {
      const result = await sendContactEmail({
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        message: formData.message,
        interest: formData.service,
        companyName: formData.company,
        preferredContactTime: ''
      });

      if (!result?.success) {
        throw new Error('Failed to send contact email');
      }
      // showNotification('Thank you! Your message has been sent successfully. Redirecting to thank you page...', 'success');

      // Reset form
      setFormData({
        name: '',
        email: '',
        phone: '',
        company: '',
        service: '',
        businessSize: '',
        message: '',
        newsletter: false
      });

      // Redirect to thank you page after 2 seconds
      setTimeout(() => {
        navigate('/thank-you');
      }, 2000);
    } catch (error) {
      console.error('Brevo Error:', error);
      // showNotification('Sorry, there was an error sending your message. Please try again or contact us directly.', 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <section id="contact" className="contact-section-new">
        <div className="container">
          <div className="contact-wrapper">
            {/* Contact Form */}
            <div className="contact-form-wrapper">
              <div className="form-header">
                <h2>Start Your AI Journey</h2>
                <p>Fill out the form below and we'll get back to you within 24 hours</p>
              </div>

              <form onSubmit={handleSubmit} className="contact-form-new">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      placeholder="Enter your full name"
                      required
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder="Enter your email address"
                      required
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="phone">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      placeholder="Enter your phone number"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="company">Company Name</label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      placeholder="Enter your company name"
                      value={formData.company}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="service">Service Interest *</label>
                    <select
                      id="service"
                      name="service"
                      required
                      value={formData.service}
                      onChange={handleChange}
                    >
                      <option value="">Select a service</option>
                      <option value="voice-agents">AI Voice Agents</option>
                      <option value="chatbots">AI Chatbots</option>
                      <option value="both">Both Services</option>
                      <option value="not-sure">Not Sure - Need Consultation</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label htmlFor="businessSize">Business Size</label>
                    <select
                      id="businessSize"
                      name="businessSize"
                      value={formData.businessSize}
                      onChange={handleChange}
                    >
                      <option value="">Select business size</option>
                      <option value="startup">Startup (1-10 employees)</option>
                      <option value="small">Small Business (11-50 employees)</option>
                      <option value="medium">Medium Business (51-200 employees)</option>
                      <option value="large">Large Business (200+ employees)</option>
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Tell us about your business needs *</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="4"
                    placeholder="Describe your current customer service challenges and how AI could help..."
                    required
                    value={formData.message}
                    onChange={handleChange}
                    maxLength="1000"
                  ></textarea>
                  <div className="char-counter">
                    {1000 - formData.message.length} characters remaining
                  </div>
                </div>

                <div className="form-group">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      name="newsletter"
                      checked={formData.newsletter}
                      onChange={handleChange}
                    />
                    <span>Subscribe to our newsletter for AI insights and updates</span>
                  </label>
                </div>

                <button type="submit" className="submit-btn" disabled={isSubmitting}>
                  <i className="fas fa-paper-plane"></i>
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            </div>

            {/* Contact Info */}
            <div className="contact-info-wrapper">
              <div className="contact-info">
                <h3>Get in Touch</h3>
                <p>Ready to transform your business with AI? Let's discuss how we can help you automate customer interactions and grow your business.</p>

                <div className="contact-details">
                  <div className="contact-item">
                    <i className="fas fa-envelope"></i>
                    <div>
                      <h4>Email</h4>
                      <p>contact@codealignr.com</p>
                    </div>
                  </div>

                  <div className="contact-item">
                    <i className="fas fa-clock"></i>
                    <div>
                      <h4>Response Time</h4>
                      <p>Within 24 hours</p>
                    </div>
                  </div>

                  <div className="contact-item">
                    <i className="fas fa-calendar-check"></i>
                    <div>
                      <h4>Free Consultation</h4>
                      <p>No obligation, no pressure</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Notification */}
      {notification && (
        <div className={`notification notification-${notification.type}`}>
          <div className="notification-content">
            <i className={`fas ${notification.type === 'success' ? 'fa-check-circle' : 'fa-exclamation-circle'}`}></i>
            <span>{notification.message}</span>
            <button className="notification-close" onClick={() => setNotification(null)}>&times;</button>
          </div>
        </div>
      )}
    </>
  );
};

export default Contact;
